import { api } from '@/services/api/AxiosBaseService'

export interface UngeneratedInvoice {
  id: string
  code: string | null
  entityType: 'subscriber' | 'company'
  entityName: string
  amount: number
  dueDate: string | null
}

export interface AsaasChargeRow {
  paymentId: string
  customerId: string | null
  value: number
  dueDate: string | null
  status: string | null
  billingType: string | null
  description: string | null
  customerName: string | null
  clientType: 'subscriber' | 'company' | null
  clientId: string | null
  clientName: string | null
}

export interface AsaasCustomerRow {
  customerId: string
  name: string
  cpfCnpj: string | null
  email: string | null
  phone: string | null
  charges: number
}

export const AsaasIntegrationService = {
  async ungeneratedInvoices(from: string, to: string): Promise<{ data: UngeneratedInvoice[]; meta: { total: number } }> {
    const r = await api.get('/integrations/asaas/ungenerated-invoices', { params: { from, to } })
    return r.data
  },
  async generateInvoice(id: string): Promise<{ id: string; externalId: string | null }> {
    const r = await api.post(`/integrations/asaas/ungenerated-invoices/${id}/generate`)
    return r.data.data
  },

  async chargeFinder(from: string, to: string): Promise<{ customersNotInSystem: AsaasCustomerRow[]; chargesNotInSystem: AsaasChargeRow[]; meta: { totalCharges?: number; fake?: boolean } }> {
    const r = await api.get('/integrations/asaas/charge-finder', { params: { from, to } })
    return { ...r.data.data, meta: r.data.meta }
  },
  async linkCharge(payload: { payment_id: string; subscriber_id?: string | null; company_id?: string | null }): Promise<{ id: string; code: string | null }> {
    const r = await api.post('/integrations/asaas/charge-finder/link', payload)
    return r.data.data
  },
  async importCustomer(payload: { customer_id: string; payment_id?: string | null }): Promise<{ subscriberId: string | null; companyId: string | null; revenueId: string | null }> {
    const r = await api.post('/integrations/asaas/charge-finder/import-customer', payload)
    return r.data.data
  },
}
